var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list .list-item.def{padding-top:.25rem;padding-bottom:.25rem}.list .list-item.last{padding-right:.5rem!important;color:#39c451}.list-header{background-color:#e1edfb}.hospital-info{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center;-webkit-box-align:center}.hospital-info .logo{width:1.5rem;height:1.5rem;background-image:url(" + escape(require("../../../static/img/hos-def-logo.png")) + ");background-size:contain;background-repeat:no-repeat;background-position:50%}.hospital-info .info{-webkit-box-flex:1;-webkit-flex:1;flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:.026667rem;padding-left:.266667rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-719bd549","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/areaSelect/AreaSelect.vue
// module id = 467
// module chunks = 0